import { Theme } from '@mui/system'
import { makeStyles } from '@mui/styles'
import { FONTS, SPACES } from 'src/constants'

const useStyles = makeStyles((theme: Theme) => ({
  icon: {
    alignSelf: 'center',
    justifySelf: 'left',
    minWidth: '80px',
    minHeight: '80px',
    maxWidth: '80px',
    maxHeight: '80px',
    marginRight: SPACES.m,
    borderTopLeftRadius: SPACES.xs,
    borderBottomLeftRadius: SPACES.xs,
    objectFit: 'cover',
  },
  box: {
    '&&': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'left',

      height: 'auto',
      widtn: '100%',
      maxWidth: 'inherit',

      borderRadius: SPACES.xs,
      boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
    },
  },
  boxActionWrapper: {
    '&&': {
      borderRadius: 10,
    },
  },
  boxContainer: {
    display: 'flex',
    alignContent: 'center',
    marginBottom: 10,
  },
  boxWrapper: {
    display: 'flex',
    flexDirection: 'row',
  },
  border: {
    border: `1px solid ${theme.palette.primary.main}`,
  },
  searchWrapper: {
    marginBottom: 10,
    display: 'flex',
    width: '100%',
    alignContent: 'center',
    justifyContent: 'center',
  },
  statisticsSectionWrapper: {
    '&&': {
      marginBottom: SPACES.xxxxxxl,
      [theme.breakpoints.down('tablet')]: {
        marginTop: SPACES.xxl,
      },
      [theme.breakpoints.up('tablet')]: {
        marginTop: SPACES.xxxxxl,
      },
      [theme.breakpoints.up('laptop')]: {
        margin: '1.75rem',
      },
    },
  },
  cardCode: {
    '&&': {
      fontSize: '12px',
      lineHeight: 1.4,
      color: 'inherit',

      textTransform: 'uppercase',
    },
  },
  titleIntroduction: {
    '&&': {
      fontWeight: FONTS.WEIGHTS.bold,
      fontSize: FONTS.SIZES.xxxxl,
      lineHeight: 1.375,
      fontFaimly: FONTS.FAMILIES.poppins,

      color: theme.palette.custom.darkBlue2,
    },
  },
  titleDescription: {
    '&&': {
      fontWeight: FONTS.WEIGHTS.light,
      fontSize: FONTS.SIZES.s,
      lineHeight: 1.333,
      fontFaimly: FONTS.FAMILIES.poppins,

      color: theme.palette.custom.darkBlue2,
    },
  },
}))

export default useStyles
